export default class DeferredPromise {
  _promise: Promise<unknown>;
  then: () => void;
  catch: () => void;
  finally: () => void;
  reject: () => void;
  resolve: (value: unknown) => void;

  constructor() {
    this._promise = new Promise((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });

    this.then = this._promise.then.bind(this._promise);
    this.catch = this._promise.catch.bind(this._promise);
    this.finally = this._promise.finally.bind(this._promise);
    this[Symbol.toStringTag] = 'Promise';
  }
}
